<template>
  <div class="openapi-use-way content-container">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="" name="1">
        <template slot="title">
          <h2>{{ $t("message.ApiTool") }}</h2>
        </template>
        <el-row>
          <el-link :href="'#/'+type+'/debug?method=' + method" type="primary" target="_blank">{{ $t("message.ApiDebugTool") }}</el-link>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  props: ['method', 'type'],
  data () {
    return {
      activeNames: ['1']
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/openapi/OpenApiTools.vue